import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-company-details-modal',
  templateUrl: './company-details-modal.component.html',
  styleUrls: ['./company-details-modal.component.scss']
})
export class CompanyDetailsModalComponent implements OnInit {
  @Input() heading: string;
  @Input() editing: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  cancelClicked() {

  }

  editCompanyDetails() {

  }

  saveCompanyDetails() {

  }
}
